// assets
import {
  IconDashboard,
  IconUser,
  IconApps,
  IconUsers,
  IconShoppingCart,
  IconClipboard,
  IconBuildingWarehouse,
  IconBrandCampaignmonitor,
  IconClipboardCheck,
  IconClick,
  IconCategory2,
  IconHierarchy2,
  IconListDetails
} from '@tabler/icons';

// constant
const icons = {
  IconDashboard,
  IconUser,
  IconApps,
  IconUsers,
  IconShoppingCart,
  IconClipboard,
  IconBuildingWarehouse,
  IconBrandCampaignmonitor,
  IconClipboardCheck,
  IconClick,
  IconCategory2,
  IconHierarchy2,
  IconListDetails
};

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const ppc = {
  id: 'ppc',
  title: 'PPC',
  type: 'group',
  children: [
    {
      id: 'ppc',
      title: 'PPC',
      type: 'collapse',
      icon: icons.IconClick,
      role: [2, 4],
      children: [
        {
          id: 'dashboard',
          title: 'Dashboard',
          type: 'item',
          url: '/dashboard',
          icon: icons.IconDashboard,
          breadcrumbs: false,
          role: [2, 4]
        },
        {
          id: 'ppc-item',
          title: 'PPC by Item',
          type: 'item',
          url: '/ppc-item',
          icon: icons.IconClipboardCheck,
          breadcrumbs: false,
          role: [2, 4]
        },
        {
          id: 'ppc-category',
          title: 'PPC by Category',
          type: 'item',
          url: '/ppc-category',
          icon: icons.IconCategory2,
          breadcrumbs: false,
          role: [2, 4]
        },

        {
          id: 'group-by-ppc',
          title: 'PPC by Group  ',
          type: 'item',
          url: '/group-by-ppc',
          icon: icons.IconHierarchy2,
          breadcrumbs: false,
          role: [2, 4]
        },

        {
          id: 'ppc-by-parent',
          title: 'PPC by Parent',
          type: 'item',
          url: '/ppc-by-parent',
          icon: icons.IconListDetails,
          breadcrumbs: false,
          role: [2, 4]
        }
      ]
    }
  ]
};

export default ppc;
